import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, LinearProgress, Typography } from '@mui/material';
import ItemListView from '../common/ItemListView';
//import './MyLearnings.css';

const CatlogListView = ({ item, onItemAction }) => {
  const navigate = useNavigate();
  const getLearnerPath = (item) => {
    switch (item.type) {
      case 'course': return `/learner/course/${item.id}`;
      case 'learning path': return `/learner/lpath/${item.id}`;
      //case 'certificate': return `/learner/certificate/${item.id}`; // adjust to real route
      //default: return `/learner/jobaid/${item.id}`; // job aid, adjust to real route
      default: return `/learner/course/${item.id}`;
    }
  };

  const getButtonText = () => {
    const isEnrolled = item.isEnrolled ?? false;
    if (!isEnrolled) return "View";
    if (item.progress === 100) return "Revisit";
    else if (item.progress === 0) return "Start";
    else if (item.progress > 0 && item.progress < 100) return "Continue";
    return "Start";
  };

  const learnerPath = getLearnerPath(item);

  // Adapt the item structure to match what ItemListView expects
  const adaptedItem = {
    id: item.id,
    name: item.name,
    title: item.name, // Ensure both name and title are available
    description: item.description,
    cover_picture: item.cover_picture,
    bookmarked: item.bookmarked || item.isBookmarked,
    status: item.status || '3', // Assuming all items in My Learnings are published
    createdAt: item.created_at,
    createdBy: item.user_id,
    progress: item.progress || 0,
    learnerPath,
    jobAids_url: item.jobAids_url,
    customButton: {
      text: getButtonText(),
      onClick: (e) => {
        e.stopPropagation();
        navigate(learnerPath);
      }
    }
  };

  return (
    <ItemListView 
      item={adaptedItem}
      onItemAction={onItemAction}
      itemType={
        item.type === 'course'
        ? 'course'
        : item.type === 'learning path'
        ? 'learningPath'
        : item.type === 'certificate'
        ? 'certificate'
        : 'job aid'
      }
    />
  );
};

export default CatlogListView;